import { NavRoute } from '@data/models/navigation.interface';
import { User } from '@data/models/user.interface';
import { compact, flatMap, isEmpty } from 'lodash';

import { defaultRoutes } from './default';

export const routes: NavRoute[] = defaultRoutes;

const flattenRoutes = (
  routes: Array<NavRoute & { ancestor?: NavRoute[] }>,
  path = '',
  ancestor?: NavRoute[],
): Array<NavRoute & { ancestors: NavRoute[] }> => {
  return flatMap(
    routes.map((route) => {
      const fullPath = (path && `${path}${route.path}`) || route.path;
      const ancestors = compact([
        ...(ancestor || []),
        {
          ...route,
          path: fullPath,
        },
      ]);

      const fullRoute = {
        ...route,
        path: fullPath,
        ancestors,
      };
      if (isEmpty(route?.children)) {
        return fullRoute;
      }
      return compact([
        ...flattenRoutes(route.children || [], fullPath, ancestors),
        (route.component && fullRoute) || null,
      ]);
    }),
  );
};

export const flatRoutes = flattenRoutes(routes);

export const getUserRoutes = (
  user: User,
): Array<NavRoute & { ancestors: NavRoute[] }> =>
  flatRoutes.filter((route) =>
    (route.permissions || ['*']).some(
      (permission) =>
        permission === '*' || user.permissions.includes(permission),
    ),
  );

export const getRouteByPathname = (
  pathname: string,
): (NavRoute & { ancestors: NavRoute[] }) | undefined => {
  return flatRoutes.find(({ path }) => path === pathname);
};

export const getRouteByFirstSegmentPathname = (
  pathname: string,
): (NavRoute & { ancestors: NavRoute[] }) | undefined => {
  return flatRoutes.find(
    ({ path }) =>
      path.slice(1).split('/')[0] === pathname.slice(1).split('/')[0],
  );
};
